import React, { ReactNode, FC } from 'react';
import Item from "./Item";

interface FormProps {
  className?: string;
  id?:string;
  onSubmit?:(e:React.FormEvent)=>  any
  children: ReactNode;
}

const Form: FC<FormProps> & { Item: typeof Item } = ({className,id,onSubmit, children }:any) => {
  return (
    <form id={id} onSubmit={onSubmit} className={className}>
      {children}
    </form>
  );
};

Form.Item = Item;

export default Form;
